import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DataService } from "src/app/Services/DataService/data.service";
import { IBaseDataList } from "src/app/Models/Interface/Base/base-data-list";
import { HttpParams } from "@angular/common/http";
import { IPagination } from "src/app/Models/Interface/Pagination/pagination";
import { APIName } from "../../../../Models/APIEndPoints/APIName";
import { IActivity } from "src/app/Models/Interface/Order/OrderDetails/Activity/activity";

@Injectable({
  providedIn: "root",
})
export class ActivitiesService {
  pagination = {
    skip: 0,
    take: 15,
    pagesCount: 0,
    inPageNumber: 1,
    leftItems: 0,
  } as IPagination;

  constructor(private dataService: DataService) {}

  getActivityList(orderId: number): Observable<IBaseDataList<IActivity[]>> {
    let params = new HttpParams();
    params = params.append("orderId", orderId);
    params = params.append("skip", this.pagination.skip);
    params = params.append("take", this.pagination.take);
    return this.dataService.getWithParams(
      APIName.order.orderDetails.activities.list,
      params
    );
  }
}
